"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseManifest = void 0;
var editor_elements_conventions_1 = require("@wix/editor-elements-conventions");
var RegistryError_1 = require("../errors/RegistryError");
function createManifestBuilder(library) {
    var manifest = {
        hosts: {},
        library: {
            url: library.topology.url,
            artifactId: library.topology.artifactId,
            environment: library.environment,
        },
    };
    var libraryAssets = [];
    return {
        isHostExist: function (host) {
            return !!manifest.hosts[host];
        },
        // --
        getHostBuilder: function (host) {
            this.ensureHostExists(host);
            var hostManifest = manifest.hosts[host];
            return {
                addUrl: function (id, url) {
                    hostManifest.id = id;
                    hostManifest.url = url;
                    return this;
                },
                addBatch: function (id, url, batchName) {
                    hostManifest.batches[batchName] = { id: id, url: url };
                    return this;
                },
                addRuntimeAsset: function (url) {
                    var existing = hostManifest.assets.find(function (_a) {
                        var type = _a.type;
                        return type === 'webpack-runtime';
                    });
                    if (existing) {
                        throw RegistryError_1.createInternalException();
                    }
                    hostManifest.assets.push({
                        url: url,
                        type: 'webpack-runtime',
                        extension: 'js',
                    });
                },
                addHotAsset: function (url) {
                    var existing = hostManifest.assets.find(function (_a) {
                        var type = _a.type;
                        return type === 'hot';
                    });
                    if (existing) {
                        throw RegistryError_1.createInternalException();
                    }
                    hostManifest.assets.push({
                        url: url,
                        type: 'hot',
                        extension: 'js',
                    });
                },
                addModelAsset: function (id, url, batch) {
                    hostManifest.assets.push({
                        id: id,
                        url: url,
                        type: 'model',
                        extension: 'js',
                        batch: batch,
                    });
                },
                addStyleAsset: function (url, batch) {
                    hostManifest.assets.push({
                        url: url,
                        type: 'style',
                        extension: 'css',
                        batch: batch,
                    });
                    return this;
                },
                getComponentBuilder: function (componentName) {
                    this.ensureComponentExists(componentName);
                    var componentManifest = hostManifest.components[componentName];
                    return {
                        addUrl: function (id, url) {
                            componentManifest.id = id;
                            componentManifest.url = url;
                            return this;
                        },
                        addPart: function (id, part, url) {
                            componentManifest.parts[part] = { id: id, url: url };
                            return this;
                        },
                        addModelAsset: function (id, url, part) {
                            componentManifest.assets.push({
                                id: id,
                                url: url,
                                type: 'model',
                                extension: 'js',
                                part: part,
                            });
                        },
                        addStyleAsset: function (url, part) {
                            componentManifest.assets.push({
                                url: url,
                                type: 'style',
                                extension: 'css',
                                part: part,
                            });
                            return this;
                        },
                    };
                },
                ensureComponentExists: function (componentName) {
                    if (!hostManifest.components[componentName]) {
                        this.addComponent(componentName);
                    }
                    return this;
                },
                addComponent: function (componentName) {
                    hostManifest.components[componentName] = {
                        name: componentName,
                        assets: [],
                        parts: {},
                    };
                    return this;
                },
            };
        },
        // --
        ensureHostExists: function (host) {
            if (!manifest.hosts[host]) {
                return this.addHost(host);
            }
            return this;
        },
        // --
        addHost: function (host) {
            manifest.hosts[host] = {
                components: {},
                batches: {},
                assets: [],
            };
            return this.getHostBuilder(host);
        },
        addLibraryAsset: function (id, url, type, extension) {
            if (extension === void 0) { extension = 'unknown'; }
            libraryAssets.push({ id: id, type: type, extension: extension, url: url });
        },
        getManifest: function () {
            /**
             * add the library assets for each host
             */
            var hosts = Object.keys(manifest.hosts).reduce(function (acc, host) {
                var _a;
                var hostManifest = manifest.hosts[host];
                return __assign(__assign({}, acc), (_a = {}, _a[host] = __assign(__assign({}, hostManifest), { assets: __spreadArrays(hostManifest.assets, libraryAssets) }), _a));
            }, {});
            return {
                library: manifest.library,
                hosts: hosts,
            };
        },
    };
}
function parseManifest(library, libraryAssetsPatterns) {
    if (libraryAssetsPatterns === void 0) { libraryAssetsPatterns = []; }
    var components = library.components;
    var builder = createManifestBuilder(library);
    Object.keys(components).forEach(function (key) {
        var _a = editor_elements_conventions_1.parseBundleName(key), host = _a.host, componentName = _a.componentName, part = _a.part, id = _a.id, batch = _a.batch, extension = _a.extension;
        /**
         * If bundle format does not match convention rules.
         * `host` should always be always decoded from the bundle name
         */
        if (!host) {
            return;
        }
        var shouldAddRuntime = !builder.isHostExist(host);
        var hostBuilder = builder.getHostBuilder(host);
        if (shouldAddRuntime) {
            if (library.environment.runtime) {
                hostBuilder.addRuntimeAsset(library.environment.runtime);
            }
            if (library.environment.hot) {
                hostBuilder.addHotAsset(library.environment.hot);
            }
        }
        var url = components[key];
        if (extension === 'js') {
            if (batch) {
                hostBuilder.addBatch(id, url, batch);
                hostBuilder.addModelAsset(id, url, batch);
            }
            else if (!componentName && !part) {
                hostBuilder.addUrl(id, url);
                hostBuilder.addModelAsset(id, url);
            }
            else if (componentName) {
                var componentBuilder = hostBuilder.getComponentBuilder(componentName);
                if (part) {
                    componentBuilder.addPart(id, part, url);
                }
                else {
                    componentBuilder.addUrl(id, url);
                }
                componentBuilder.addModelAsset(id, url, part);
            }
            else {
                throw RegistryError_1.createInternalException();
            }
        }
        else if (extension === 'css') {
            if (batch) {
                hostBuilder.addStyleAsset(url, batch);
            }
            else if (!componentName && !part) {
                hostBuilder.addStyleAsset(url);
            }
            else if (componentName) {
                var componentBuilder = hostBuilder.getComponentBuilder(componentName);
                componentBuilder.addStyleAsset(url, part);
            }
            else {
                throw RegistryError_1.createInternalException();
            }
        }
    });
    libraryAssetsPatterns.forEach(function (_a) {
        var type = _a.type, pattern = _a.pattern;
        Object.keys(library.components).forEach(function (id) {
            var url = library.components[id];
            if (pattern.test(id)) {
                var extension = url.split('.').pop();
                builder.addLibraryAsset(id, url, type, extension);
            }
        });
    });
    return builder.getManifest();
}
exports.parseManifest = parseManifest;
//# sourceMappingURL=parseManifest.js.map